import React from 'react'
import { useTable, usePagination, useSortBy, useFilters } from 'react-table'
import PartyFilter from './PartyFilter';
import CategoryFilter from './CategoryFilter';
import generateExcel from "zipcelx";

export default function ResultTable({ columns, data, features }) {
  const parties = data.map(data => data.IdKey)
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    rows,
    setFilter,
    setHiddenColumns,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useSortBy,
    usePagination,
  )
  function getHeader(column) {
      return [
        {
          value: column.Header,
          type: "string"
        }
      ];
  }
  const getExcel = () => {
    const config = {
            filename: "features",
            sheet: {
          	  data: []
            }
    };
    const dataSet = config.sheet.data;
    headerGroups.forEach(headerGroup => {
      const headerRow = [];
      if (headerGroup.headers) {
        headerGroup.headers.forEach(column => {
          headerRow.push(...getHeader(column));
        });
      }

      dataSet.push(headerRow);
    });

    // FILTERED ROWS
    if (rows.length > 0) {
      rows.forEach(row => {
        const dataRow = [];

        Object.values(row.values).forEach(value =>
          dataRow.push({
            value,
            type: typeof value === "number" ? "number" : "string"
          })
        );

        dataSet.push(dataRow);
      });
    } else {
      dataSet.push([
        {
          value: "No data",
          type: "string"
        }
      ]);
    }

    return generateExcel(config);
  }

  // Render the UI for your table
  return (
    <>
      <div className="mb-3 flex">
        <PartyFilter parties={parties} setFilter={setFilter} />
        <CategoryFilter columns={columns} features={features} setHiddenColumns={setHiddenColumns} />
      </div>
      <div className="w-full overflow-x-scroll">
        <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative" {...getTableProps()}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr className="text-left" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th className="bg-purple-l sticky top-0 border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-xs" {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render('Header')}
                    {/* Add a sort direction indicator */}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? <i className="fas fa-chevron-down ml-1"></i>
                          : <i className="fas fa-chevron-up ml-1"></i>
                        : ''}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return (
                      <td className="border-dashed border-t border-gray-200" {...cell.getCellProps()}>
                        <span className="text-gray-800 px-6 py-3 flex items-center">
			    {(() => {
				    const value = cell.value;
				    let parsedValue = parseFloat(value);

				    if (parsedValue) {
					    return Number.isInteger(parsedValue) ? parsedValue : parsedValue.toFixed(2);
				    }

				    return cell.render('Cell');
				    })()}
                        </span>
                      </td>
                  )})}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
      <div className="pagination my-2">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage} className="shadow rounded-lg inline-flex items-center bg-white hover:text-purple-500 focus:outline-none focus:shadow-outline text-gray-500 font-semibold py-2 px-2 md:px-4">
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage} className="shadow rounded-lg inline-flex items-center bg-white hover:text-purple-500 focus:outline-none focus:shadow-outline text-gray-500 font-semibold py-2 px-2 md:px-4">
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage} className="shadow rounded-lg inline-flex items-center bg-white hover:text-purple-500 focus:outline-none focus:shadow-outline text-gray-500 font-semibold py-2 px-2 md:px-4">
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} className="shadow rounded-lg inline-flex items-center bg-white hover:text-purple-500 focus:outline-none focus:shadow-outline text-gray-500 font-semibold py-2 px-2 md:px-4">
          {'>>'}
        </button>{' '}
        <span className="text-gray-800 px-6 py-1">
          Page{' '}
          <strong className="text-gray-800 px-6 py-1">
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        {/* <span>
          | Go to page:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select> */}
      </div>
      <div>
	  <button onClick={getExcel} className='text-gray-800 bg-white mt-3 hover:text-purple-500 font-semibold py-2 px-4 border border-gray-400 rounded shadow'>Download</button>
      </div>
    </>
  )
}
